import "./Loading.css";

const Loading= () => {
    return (

    <div className="section-loading">
        <div className="loading">
            {/*les "style"} ne fonctionnent pas en React. Je les laisse en comment pour le moment*/}
            <div className="blocks" /*style="--i:1;"*/></div>
            <div className="blocks" /*style="--i:2;"*/></div>
            <div className="blocks" /*style="--i:3;"*/></div>
            <div className="blocks" /*style="--i:4;"*/></div>
            <div className="blocks" /*style="--i:5;"*/></div>
            <div className="blocks" /*style="--i:6;"*/></div>
            <div className="blocks" /*style="--i:7;"*/></div>
            <div className="blocks" /*style="--i:8;"*/></div>
            <div className="blocks" /*style="--i:9;"*/></div>
            <div className="blocks" /*style="--i:10;"*/></div>
            <div className="blocks" /*style="--i:11;"*/></div>
            <div className="blocks" /*style="--i:12;"*/></div>
            <div className="blocks" /*style="--i:13;"*/></div>
            <div className="blocks" /*style="--i:14;"*/></div>
            <div className="blocks" /*style="--i:15;"*/></div>
            <div className="blocks" /*style="--i:16;"*/></div>
            <div className="blocks" /*style="--i:17;"*/></div>
            <div className="blocks" /*style="--i:18;"*/></div>
            <div className="blocks" /*style="--i:19;"*/></div>
            <div className="blocks" /*style="--i:20;"*/></div>
            <h3>Loading...</h3>
        </div>
    </div>    
    )
}

export default Loading;